import {isDevEnv} from '../../../utils/platform';
import {AnnouncementItems} from '../consts/types';
import {ver2401} from './ver2401';

export const getAnnouncements = () => {
    return {
        '24.01': ver2401()
    };
};

export const getVersionAnnouncements: (
    PriorityVersion
) => AnnouncementItems[] = PriorityVersion => {
    if (isDevEnv()) {
        return getAnnouncements()['25.00'];
    }
    return getAnnouncements()[PriorityVersion];
};
